import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import ProtectedRoute from '../components/ProtectedRoute';

/**
 * User Profile Page Component
 */
const Profile = () => {
  const { user } = useAuth();
  const { subscription, isSubscribed } = useSubscription();

  if (!user) {
    return null;
  }

  return (
    <ProtectedRoute>
      <div className="container" style={{ paddingTop: '30px' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
          👤 Profile
        </h1>

        <div className="card" style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--highlight-color)', marginBottom: '20px' }}>
            Account Information
          </h2>
          <div style={{ display: 'grid', gap: '15px' }}>
            <div>
              <strong>Name:</strong> {user.name || 'N/A'}
            </div>
            <div>
              <strong>Email:</strong> {user.email}
            </div>
            <div>
              <strong>Role:</strong> {user.role || 'customer'}
            </div>
            <div>
              <strong>Member Since:</strong> {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}
            </div>
          </div>
        </div>

        <div className="card" style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--highlight-color)', marginBottom: '20px' }}>
            Subscription Status
          </h2>
          {subscription ? (
            <div>
              <p style={{ marginBottom: '10px' }}>
                <strong>Plan:</strong> {subscription.planId === 'premium' ? 'Premium' : 'Free'}
              </p>
              <p style={{ marginBottom: '10px' }}>
                <strong>Status:</strong> {subscription.status}
              </p>
              <p style={{ marginBottom: '10px' }}>
                <strong>Start Date:</strong> {new Date(subscription.startDate).toLocaleDateString()}
              </p>
              {subscription.endDate && (
                <p style={{ marginBottom: '10px' }}>
                  <strong>End Date:</strong> {new Date(subscription.endDate).toLocaleDateString()}
                </p>
              )}
              {!isSubscribed() && (
                <Link to="/subscription" className="btn btn-primary" style={{ marginTop: '15px', display: 'inline-block' }}>
                  Upgrade to Premium
                </Link>
              )}
            </div>
          ) : (
            <div>
              <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
                You are currently on the Free plan.
              </p>
              <Link to="/subscription" className="btn btn-primary">
                View Plans & Subscribe
              </Link>
            </div>
          )}
        </div>

        <div className="card" style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--highlight-color)', marginBottom: '20px' }}>
            Quick Links
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Link to="/launches" className="btn btn-secondary">View Upcoming Launches</Link>
            {isSubscribed() && <Link to="/articles/create" className="btn btn-secondary">Create Article</Link>}
            {isSubscribed() && <Link to="/chat" className="btn btn-secondary">Chat Rooms</Link>}
            {!isSubscribed() && <Link to="/subscription" className="btn btn-primary">Subscribe for Premium Features</Link>}
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default Profile;
